export class WebSocketService {
  constructor(url) {
    this.url = url;
    this.socket = null;
    this.connect();
  }

  connect() {
    this.socket = new WebSocket(this.url);

    this.socket.onopen = () => {
      console.log('WebSocket connection opened');
    };

    this.socket.onclose = (event) => {
      console.log('WebSocket connection closed:', event);
      this.reconnect();
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    this.socket.onmessage = (message) => {
      // console.log('WebSocket message received:', message.data);
      this.handleMessage(message.data);
    };
  }

  reconnect() {
    setTimeout(() => {
      console.log('Reconnecting WebSocket...');
      this.connect();
    }, 5000); // 5秒后重连
  }

  sendMessage(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
    } else {
      console.error('WebSocket is not open');
    }
  }

  handleMessage(message) {
    // 处理接收到的消息
    console.log('Handle message:', message);
  }
}